/** URL segments for the shell: admin app vs operations (stock) microfrontend area */
export const ROUTE_PREFIX = {
  ADMIN: '/admin',
  OPERATIONS: '/operations',
}

/** Join a shell prefix with an app-internal route (e.g. `/dashboard` → `/admin/dashboard`). */
export function joinRoutePrefix(prefix, route) {
  if (route == null || route === '') return prefix || ''
  const p = (prefix || '').replace(/\/$/, '')
  const r = route.startsWith('/') ? route : `/${route}`
  return `${p}${r}`
}

/** After login / default landing for the main admin shell */
export const DEFAULT_POST_LOGIN_PATH = joinRoutePrefix(ROUTE_PREFIX.ADMIN, '/dashboard')

/**
 * Recursively prefix `route` on permission nodes from the API so links match the shell URL.
 */
export function prefixPermissionTree(nodes, prefix) {
  if (!nodes?.length) return nodes
  return nodes.map((node) => {
    const n = { ...node }
    if (n.route) n.route = joinRoutePrefix(prefix, n.route)
    if (n.subPage?.length) n.subPage = prefixPermissionTree(n.subPage, prefix)
    return n
  })
}

/** Strip `/admin` or `/operations` so permission routes (`/dashboard`, …) match `location.pathname`. */
export function stripShellPrefix(pathname) {
  if (!pathname) return pathname
  for (const p of [ROUTE_PREFIX.ADMIN, ROUTE_PREFIX.OPERATIONS]) {
    if (pathname === p || pathname === `${p}/`) return '/'
    if (pathname.startsWith(`${p}/`)) return pathname.slice(p.length)
  }
  return pathname
}
